<template>
  <div>
    <div class="nav">
      <v-head></v-head>
    </div>
     <v-route :bindData="bindData"></v-route>
    <div class="container">
      <div class="list_breadcrumb">
        <span class="hover" @click="to1()">首页</span> ＞
        <span class="hover" @click="to2()">虚拟游</span> ＞
        <span class="hover" @click="to3()">场景切换</span>
        ＞ <span class="hover">{{ title }}</span>
      </div>
      <h2>{{ title }}</h2>

      <iframe
        :src="href"
        style="width: 100%; height: 720px; margin-bottom: 50px"
      ></iframe>
    </div>

    <v-footer></v-footer>
  </div>
</template>

<script>
import route from '../../components/common/route1'
export default {
  name: "list1",
  data() {
    return {
      href: null,
      title: null,
       bindData:null,
      url: [
        "720",
        "40288a9d6e91c70a016e91c895ae0001",
        "40288a9d6e91c70a016e91cc6eb5000a",
      ],
    };
  },
   components:{
            "v-route":route,
        },
  created() {
    this.initBindData();  
    this.href = this.$route.query.href;
    this.title = this.$route.query.title;
  },
    watch:{
            $route:function () {
    this.initBindData();  
            }},
  methods: {
    to1() {
      location.href = "index.html";
    },
    to2(){
          this.$router.push({
            path: `vr?ljcode=720&columnId=40288a9d6e91c70a016e91cc6eb5000a&rootColumnId=40288a9d6e91c70a016e91c895ae0001`,
          });
    },
    to3(){
        this.$router.push({
            path: `cjqh?ljcode=cjqh&rootColumnId=40288a9d6e91c70a016e91c895ae0001&columnId=cjqh`,
          });
    },
    initBindData(){
                switch (this.$route.query.rootColumnId) {
                    case '40288a9d6e91c70a016e91c895ae0001':
                        this.bindData=[
                            {
                                name:'720°全景游览',
                                url:'#/vr?ljcode=720&columnId=40288a9d6e91c70a016e91cc6eb5000a&rootColumnId=40288a9d6e91c70a016e91c895ae0001',
                                cid:'2c9a4c9b6ea63d8c016ea6474f040002'
                            },
                            {
                                name:'漫游讲解',
                                url:'#/myjj?ljcode=myjj&columnId=2c9a4c9b6ea63d8c016ea6474f040002&rootColumnId=40288a9d6e91c70a016e91c895ae0001',
                                cid:'2c9a4c9b6ea63d8c016ea6474f040002'
                            },
                            {
                                name:'场景切换',
                                url:'#/720?ljcode=cjqh&rootColumnId=40288a9d6e91c70a016e91c895ae0001&columnId=cjqh',
                                cid:'cjqh'
                            }
                        ];
                        break;
                }
      
            },
  },
};
</script>

<style lang="less" scoped>
.nav {
  height: 350px;
  background: url("../../assets/img/headerbanner.jpg");
}
.container {
  text-align: center;
  h2 {
    font-size: 36px;
    line-height: 70px;
    height: 70px;
    color: black;
    letter-spacing: 5px;
    text-align: center;
  }
}
.list_breadcrumb {
  height: 55px;
  line-height: 55px;
  text-align: left;
  font-size: 16px;
  color: #666666;
  border-bottom: 1px solid rgba(215, 220, 226, 1);
  font-weight: 600;
}
</style>
